import './App.css';
import { useEffect, useState } from 'react';
import AnalogClock from './AnalogClock';
import { ko } from 'date-fns/locale';
import { format } from 'date-fns';
import styled from 'styled-components';
import Watch from './Watch';

const DigitalClock = () => {
  const [state, setState] = useState("stop");
  const [prime, setPrime] = useState(60);
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDate(new Date());
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const formattedDate = format(date, 'HH:mm:ss', { locale: ko });
  const [hours, minutes, seconds] = formattedDate.split(':');

  date.toLocaleDateString();
  const day = parseInt(hours / 6);
  const _hour = String(hours % 6).padStart(2, '0');

  const _total = _hour * 60 * 60 + minutes * 60 + seconds * 1;
  const _percentage = (_total) * 100 / (3600 * 6);

  const koDays = ['0번째 날', '첫 번째 날', '두 번째 날', '세 번째 날']

  const dHour = String(parseInt(_total / (prime * 60))).padStart(2, '0');
  const dMin = String(parseInt(_total % (prime*60) / prime)).padStart(2, '0');
  const dSec = String(parseInt(_total % (prime) * (60/prime))).padStart(2, '0');

  return (
    <div>
        <p style={{fontSize: 26, fontWeight: '700', margin: 0}}>
          에드 마일렛의 시계
        </p>
        <p style={{marginBottom: 20,  fontSize: 13, fontWeight: '500'}}>
          <a 
            style={{color: '#aaa'}}
            href='https://www.instagram.com/reel/CmsK0owgnFt/?igshid=MDJmNzVkMjY%3D'
            target="_blank"
          >
            관련 영상 보기
          </a>
        </p>
        <AnalogClock 
          locale={ko}
          speed={60/prime}  
        />
      <p style={{fontSize: 15, color: '#aaa'}}>
        {format(date, "yy년 M월 dd일", { locale: ko})}의 
        <span style={{fontSize: 24, color: 'white', fontWeight: 'bold'}}> {koDays[day]}</span>
      </p>

      <p style={{fontSize: 15, color: '#aaa', padding: "20px 0 0"}}>
        {"시간 쪼개기 : "}
        {
          [60,40,30,24,20].map((v, i) => (
            <MultipleClock
              key={i}
              active={prime === v}
              onClick={() => setPrime(v)}
            >{
              v === 60 ? "안함" : 60/v+"배"
            }</MultipleClock>
          ))
        }
      </p>

      <p style={{fontSize: 15, color: '#aaa'}}>
        {prime !== 60 ? 60/prime+'x ' : ''}하루 시간 :
        <span style={{fontSize: 24, color: state === 'stop' ? 'white' : "#999", fontWeight: 'bold'}}>
          {" "+dHour+":"+dMin+" "}
        </span>
        / {String(360 / prime).padStart(2, '0')}:00 ({_percentage.toFixed(0)}%)
      </p>
      <Watch 
        multiply={60/prime}
        state={state}
        setState={setState}  
      />
      {/* <p style={{color: '#666', fontSize: 14, paddingTop: 25, marginBottom: 20}}>
        실제 시간 : {date.toLocaleDateString()} {formattedDate}
      </p> */}
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <DigitalClock />
        <p style={{
          color: '#666', fontSize: 12, margin: 0,
          position: 'fixed',
          bottom: 0,
          backgroundColor: '#282c34',
          width: '100%',
          paddingBottom: 2,
        }}>
          Made by <a 
            style={{color: '#666', textDecoration: 'none'}}
            href='https://www.instagram.com/steelless_dojun'
          >@dojun</a>
        </p>
      </header>
    </div>
  );
}

export default App;

const MultipleClock = styled.span`
  font-size: 17px;
  padding: 1px;
  margin: 0 8px 0 3px;
  color: ${props => props.active ? 'white' : '#aaa'};
  font-weight: ${props => props.active ? 'bold' : 'normal'};
`